import { Subject } from 'rxjs';
import { Flashbag, FlashbagType } from '@shared/definitions/flashbag';
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class FlashbagService {
  constructor() {}

  flashbag: Subject<Flashbag> = new Subject<Flashbag>();

  messageToDisplay(title: string, message: string, type: FlashbagType, length = 4000) {
    const tmpFlashbag: Flashbag = new Flashbag(title, message, type, length);
    this.flashbag.next(tmpFlashbag);
  }
} 